import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { MultiBoardGuestAlertProps } from './MultiBoardGuestAlert';

export const LazyMultiBoardGuestAlert: FunctionComponent<
  MultiBoardGuestAlertProps
> = (props) => {
  const MultiBoardGuestAlert = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "multi-board-guest-alert" */ './MultiBoardGuestAlert'
      ),
    { namedImport: 'MultiBoardGuestAlert' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Multi Board Guest Alert',
      }}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <MultiBoardGuestAlert {...props} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
